import { PublicKey } from "@solana/web3.js";

// export const caffeineTokenMint = new PublicKey("32JXVurQacMxQF6qFxKkeAbysQcXsCakuYx3eyYRBoSR");
export const crmMint = new PublicKey(
  "CRMaDAzKCWYbhUfsKYA8448vaA1qUzCETd7gNBDzQ1ks"
  // "5WxyHNWaTzQZTAtHYSVYmMpbTt1PhgQ32fsrDWbSK8vG"
  // "CrMKwgPf5qFmvamgvZ7sdUiK4vYrwaHi9WK5qabJvddS"
);
// const openRewardTimestamp = 1646902112;
// export const minter = "CVt4V1ArFU8tkHDCN6tSCNp9qAhCjHYcmbxtjHbmFpj8";
// export const mintWrapper = "9qATBSgQjUEKYTsQjyu599G2cNpr3qkkyqrHqGpbwLKz";
// export const mintWrapper = "D6vKcELApqAicZ3Rj5i393Pk3mQHo5FbRMsbMJYyMECn";
// export const minter = "8kxHAvPbnF8Cbw7qj8rJJHFZopuiEfUL8FA9jxqnmp5i";
export const mintWrapperProgram = new PublicKey(
  "CMWr5a5feRxAeowwHcm1u5bYwmUvsAjcBbqLRcBshyAR"
);
export const transferWrapperProgram = new PublicKey(
  "CTWrBmckXuRs89bwFBebh67nvv1kHpiFPNYe1o3JnSKa"
);

/////////////////////////////
// export const transfer_mint_1 = new PublicKey("SP1PpoeB8T4kjtkq5X33nXkk4okZTutoYhstszQnRAn")
// export const transfer_1_token_account = new PublicKey("4bN79jDAzR3srvRQ9kUzQKMLyUdc2ZCwJSTgMFiBiUVh")
//  transfer wrapper: 8BqTiExR5ApVyj1d1SLVVh4jgCAQ6C7Q3Pgb7qNE6VCu
/// transferer: Bd2NPGMpBRfKfXE5RBJ6cdpkLTvDHH5goKKBfD572o99
//
// export const transfer_mint_2 = new PublicKey("9xGCV4ccYXgHardGekZMvmLJhgvXbhVq9gHabocRzzFo")
//transfer wrapper: DsWs6HHrQ8r3Jw54ULr4RCkTvM2a7x8Vq7iV3xoJU3ps
//transferer: yBygVM6zqu7ob7Lc8YvvkxJPqVGgwtc5EvmjyM1WHdp

// export const transfer_mint_3 = new PublicKey("5mNZoQsBzwQ6LrHZ4yrbY4m83cPhezzw1boYASrbTJvi")
//transfer wrapper: AMc4TB2wcPRw84TwRizJz1E53cd1gpAfufU6QodokyD7
//transferer: 4NNcrN7qKgYyngcDqtW4qtLJQ4HandUVijJoX9Ns31SA

// export const transfer_mint_4 = new PublicKey("4sfM9JPqEjaKR3XSM3k4urvfhgGrANt5Gb5hnybK6FeQ")
//transfer wrapper: 8uBDvH9BpnqK5Qp5PNx32N8oxixVfPNHQ6FbVhgsczWo
//transferer: B5wggBZZAd2wfhbaUuCUAoqBG9Jp6TEPGxKvbHPzCGCF

// export const transfer_mint_5 = new PublicKey("7uKZzUp7f8mrEp1qVqqc3jCvtUELny6hTdyNL1oc5aWr")
//transfer wrapper: DgBLuucUmDJ9u6ZJL1bddjDrJzxNCQ3dyfBtsRPLPXXU
//transferer: GGWeTVXStmpBN5smraF3HcgSRLu8zzJPksymMFWx54KE

// export const transfer_mint_6 = new PublicKey("BRteh3cSPtM9ARQrBPm5wiGDo2Ri9jRX7LNkmw3XnwLk")
//transfer wrapper: FxWm3jVpuTGkcVq9FXF5LnkyMnYg3BaZrhhHq7iNeGvJ
//transferer: 4He2jGHaC4qhnXdnuBGvTLkgrJrZbYi7KYdPFZHFTHi7

// export const mints = {
//     "SP1PpoeB8T4kjtkq5X33nXkk4okZTutoYhstszQnRAn": transfer_mint_1,
//     "9xGCV4ccYXgHardGekZMvmLJhgvXbhVq9gHabocRzzFo": transfer_mint_2,
//     "5mNZoQsBzwQ6LrHZ4yrbY4m83cPhezzw1boYASrbTJvi": transfer_mint_3,
//     "4sfM9JPqEjaKR3XSM3k4urvfhgGrANt5Gb5hnybK6FeQ": transfer_mint_4,
//     "7uKZzUp7f8mrEp1qVqqc3jCvtUELny6hTdyNL1oc5aWr": transfer_mint_5,
//     "BRteh3cSPtM9ARQrBPm5wiGDo2Ri9jRX7LNkmw3XnwLk": transfer_mint_6
// }

// export const wrappers = {
//     "SP1PpoeB8T4kjtkq5X33nXkk4okZTutoYhstszQnRAn": new PublicKey("8BqTiExR5ApVyj1d1SLVVh4jgCAQ6C7Q3Pgb7qNE6VCu"),
//     "9xGCV4ccYXgHardGekZMvmLJhgvXbhVq9gHabocRzzFo": new PublicKey("DsWs6HHrQ8r3Jw54ULr4RCkTvM2a7x8Vq7iV3xoJU3ps"),
//     "5mNZoQsBzwQ6LrHZ4yrbY4m83cPhezzw1boYASrbTJvi": new PublicKey("AMc4TB2wcPRw84TwRizJz1E53cd1gpAfufU6QodokyD7"),
//     "4sfM9JPqEjaKR3XSM3k4urvfhgGrANt5Gb5hnybK6FeQ": new PublicKey("8uBDvH9BpnqK5Qp5PNx32N8oxixVfPNHQ6FbVhgsczWo"),
//     "7uKZzUp7f8mrEp1qVqqc3jCvtUELny6hTdyNL1oc5aWr":new PublicKey("DgBLuucUmDJ9u6ZJL1bddjDrJzxNCQ3dyfBtsRPLPXXU"),
//     "BRteh3cSPtM9ARQrBPm5wiGDo2Ri9jRX7LNkmw3XnwLk":new PublicKey("FxWm3jVpuTGkcVq9FXF5LnkyMnYg3BaZrhhHq7iNeGvJ")
// }

// export const transferers = {
//     "SP1PpoeB8T4kjtkq5X33nXkk4okZTutoYhstszQnRAn": new PublicKey("Bd2NPGMpBRfKfXE5RBJ6cdpkLTvDHH5goKKBfD572o99"),
//     "9xGCV4ccYXgHardGekZMvmLJhgvXbhVq9gHabocRzzFo": new PublicKey("yBygVM6zqu7ob7Lc8YvvkxJPqVGgwtc5EvmjyM1WHdp"),
//     "5mNZoQsBzwQ6LrHZ4yrbY4m83cPhezzw1boYASrbTJvi": new PublicKey("4NNcrN7qKgYyngcDqtW4qtLJQ4HandUVijJoX9Ns31SA"),
//     "4sfM9JPqEjaKR3XSM3k4urvfhgGrANt5Gb5hnybK6FeQ": new PublicKey("B5wggBZZAd2wfhbaUuCUAoqBG9Jp6TEPGxKvbHPzCGCF"),
//     "7uKZzUp7f8mrEp1qVqqc3jCvtUELny6hTdyNL1oc5aWr":new PublicKey("GGWeTVXStmpBN5smraF3HcgSRLu8zzJPksymMFWx54KE"),
//     "BRteh3cSPtM9ARQrBPm5wiGDo2Ri9jRX7LNkmw3XnwLk":new PublicKey("4He2jGHaC4qhnXdnuBGvTLkgrJrZbYi7KYdPFZHFTHi7"),
// }

// export const source_token_accounts = {
//     "SP1PpoeB8T4kjtkq5X33nXkk4okZTutoYhstszQnRAn": new PublicKey("FPWXR2SYzRv1EQBPGEkYwiSGSz9TEcywLGTvtPm89kV8"),
//     "9xGCV4ccYXgHardGekZMvmLJhgvXbhVq9gHabocRzzFo": new PublicKey("3xydUYd7mQR5XZwyqudXYP9yyEpuZaccWVqFyddywt3e"),
//     "5mNZoQsBzwQ6LrHZ4yrbY4m83cPhezzw1boYASrbTJvi": new PublicKey("ErHHmQxiVG6fSJtBsXF8XraDhNn1GZPWNwE4NJMV4QKy"),
//     "4sfM9JPqEjaKR3XSM3k4urvfhgGrANt5Gb5hnybK6FeQ": new PublicKey("H799wcUHemnrT979h5192vjRpRUE6YvbJYeMRWRSpeJk"),
//     "7uKZzUp7f8mrEp1qVqqc3jCvtUELny6hTdyNL1oc5aWr":new PublicKey("EwCDvLHGY2uk45h8DHP6dQogTMb4kvqzZVLCX3ZQYhKd"),
//     "BRteh3cSPtM9ARQrBPm5wiGDo2Ri9jRX7LNkmw3XnwLk":new PublicKey("6CUojTQngPUnRroaERJwQqo5uP5EMG8Zb14qibovxSGi")
// }
